import { useSelector } from "react-redux";
import CompSelector from "../CompSelector";
import { RootState } from "../../reducers";
import { CompetitionFilterPanel } from "./styles";

interface Props {
  competitions: string[];
}

const CompetitionFilter = ({ competitions }: Props) => {
  const filterStore = useSelector((state: RootState) => state.filter);

  return (
    <CompetitionFilterPanel>
      {competitions.map((competition, key: number) => (
        <CompSelector
          key={key}
          competition={competition}
          selection={filterStore.competitions}
        />
      ))}
    </CompetitionFilterPanel>
  );
};

export default CompetitionFilter;
